import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';

export const useUpdateBillingGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation(['billingGroups']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      billingGroupId,
      name,
      discountTemplatesIds,
    }: {
      billingGroupId: number;
      name: string;
      discountTemplatesIds: number[];
    }) => billingGroupApi.updateBillingGroup(billingGroupId, name, discountTemplatesIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: billingGroupsKeys.all,
      });
      toast.success(
        `${t('billingGroups:create.billingGroup')} ${t('billingGroups:create.edited')}`,
      );

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
